import { render, staticRenderFns } from "./RolesAndPermissions.vue?vue&type=template&id=3e9265a4"
import script from "./RolesAndPermissions.vue?vue&type=script&lang=js"
export * from "./RolesAndPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e9265a4')) {
      api.createRecord('3e9265a4', component.options)
    } else {
      api.reload('3e9265a4', component.options)
    }
    module.hot.accept("./RolesAndPermissions.vue?vue&type=template&id=3e9265a4", function () {
      api.rerender('3e9265a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/user/RolesAndPermissions.vue"
export default component.exports